import { LRUCache } from "lru-cache";
import * as APITypes from "~/API";
import { MAX_CACHE_ITEMS, MILLI_SECONDS } from "../property";
import { LoaderData } from "~/types";
import { EMPTY_RESOURCE_UPDATE_ACCESS_RIGHT_INFO } from "~/services/server";

export class ResourceAccessLRUCache {
  private static cache: LRUCache<
    string,
    LoaderData<APITypes.ResourceUpdateAccessRight>
  >;

  public static getCacheInstance() {
    if (ResourceAccessLRUCache.cache) {
      return ResourceAccessLRUCache.cache;
    }

    ResourceAccessLRUCache.cache = new LRUCache<
      string,
      LoaderData<APITypes.ResourceUpdateAccessRight>
    >({
      max: MAX_CACHE_ITEMS,
      ttl: 5 * MILLI_SECONDS, // 5 second TTL, same as PropertyLRUCache
    });
    return {
      success: true,
      data: ResourceAccessLRUCache.cache,
    };
  }

  public static get(
    key: string
  ): LoaderData<LoaderData<APITypes.ResourceUpdateAccessRight>> {
    ResourceAccessLRUCache.getCacheInstance();

    const value = ResourceAccessLRUCache.cache.get(key);
    if (value === undefined) {
      return {
        success: false,
        data: {
          success: false,
          data: EMPTY_RESOURCE_UPDATE_ACCESS_RIGHT_INFO,
        },
        error: new Error(`entry not found for key: ${key}`),
      };
    }

    return {
      success: true,
      data: value,
    };
  }

  public static update({
    key,
    value,
  }: {
    key: string;
    value: LoaderData<APITypes.ResourceUpdateAccessRight>;
  }) {
    if (!ResourceAccessLRUCache.cache) {
      ResourceAccessLRUCache.cache = new LRUCache<
        string,
        LoaderData<APITypes.ResourceUpdateAccessRight>
      >({
        max: MAX_CACHE_ITEMS,
        ttl: 5 * MILLI_SECONDS, // 5 second TTL
      });
    }

    // TODO: handle the result
    const result = ResourceAccessLRUCache.cache.set(key, value);
    return {
      success: true,
      data: ResourceAccessLRUCache.cache,
    };
  }

  /**
   * Clear the entire cache or a single element in the cache
   *
   * @param key optional: the key for the element to be removed from the cache.
   * If not passed, then entire cache is cleared
   * @returns
   */
  public static clear({ key }: { key?: string }) {
    if (!ResourceAccessLRUCache.cache) {
      ResourceAccessLRUCache.cache = new LRUCache<
        string,
        LoaderData<APITypes.ResourceUpdateAccessRight>
      >({
        max: MAX_CACHE_ITEMS,
        ttl: 5 * MILLI_SECONDS, // 5 second TTL
      });
    }

    if (key) {
      const isDeleted = ResourceAccessLRUCache.cache.delete(key);
      return {
        success: isDeleted,
        data: ResourceAccessLRUCache.cache,
        error: isDeleted
          ? new Error(`error deleting ${key} from the auth cache`)
          : null,
      };
    }

    ResourceAccessLRUCache.cache.clear();
    return {
      success: true,
      data: ResourceAccessLRUCache.cache,
    };
  }
}
